import { Helmet } from "react-helmet";
import { DashboardLayout } from "../../../components/layouts/DashboardLayout";
import { Header } from "../../../components/Header";
import { useState, useRef } from "react";
import {
  FaUser,
  FaLock,
  FaGear,
  FaFloppyDisk,
  FaGlobe,
  FaBell,
  FaCamera,
  FaXmark,
  FaBuilding,
  FaBoxOpen, // Icon untuk tab Langganan
  FaCheck,
  FaCrown,
  FaRotate,
  FaClock,
} from "react-icons/fa6";
import { HeaderTabSetting } from "./tabs/header";
import { TabSubscriptionPlanSetting } from "./tabs/cotents/subscription";
import { useHookCompanyByCompany } from "../../../hooks/useHookShowCompanyByCompany";
import { TabCompanySetting } from "./tabs/cotents/company";
import { TabSecuritySetting } from "./tabs/cotents/security";
import { TabProfileSetting } from "./tabs/cotents/profile";

/* ============================================
   KOMPONEN: Toggle Switch (Dark Mode)
   ============================================ */
const ToggleSwitch = ({ defaultChecked = false }) => {
  const [checked, setChecked] = useState(defaultChecked);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => setChecked(!checked)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 focus:outline-none ${checked ? "bg-cyan-500" : "bg-slate-700"
        }`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${checked ? "translate-x-6" : "translate-x-1"
          }`}
      />
    </button>
  );
};

/* ============================================
   DATA DUMMY: Paket Langganan
   ============================================ */
const subscriptionPackages = [
  {
    id: "starter",
    name: "Starter",
    price: "Rp150.000",
    period: "/bulan",
    desc: "Cocok untuk jaringan baru",
    features: [
      "Hingga 100 Pengguna PPPoE",
      "1 Koneksi Mikrotik",
      "Manajemen Tiket Gangguan",
      "Laporan Bulanan Dasar",
    ],
    popular: false,
  },
  {
    id: "professional",
    name: "Professional",
    price: "Rp350.000",
    period: "/bulan",
    desc: "Untuk bisnis yang berkembang",
    features: [
      "Hingga 500 Pengguna PPPoE",
      "3 Koneksi Mikrotik",
      "Integrasi WhatsApp Api",
      "Payment Gateway (Midtrans/QRIS)",
      "Laporan & Analitik Lanjutan",
    ],
    popular: true,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "Rp750.000",
    period: "/bulan",
    desc: "Solusi skala besar tanpa batas",
    features: [
      "Pengguna PPPoE Unlimited",
      "Koneksi Mikrotik Unlimited",
      "Priority Support 24/7",
      "Custom Fitur Sesuai Kebutuhan",
      "White Label Branding",
    ],
    popular: false,
  },
];

/* ============================================
   KOMPONEN: Setting
   ============================================ */
export const Setting = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [activeTab, setActiveTab] = useState("subscription");

  // State Paket Aktif Saat Ini
  const [activePackage, setActivePackage] = useState("professional");
  const [expireDate, setExpireDate] = useState("15 November 2024"); // Dummy

  // Refs
  const fileInputRef = useRef(null);
  const companyFileInputRef = useRef(null);

  const { data: dataCompany, refreshData: refreshDataCompany, loading: loadingCompany, error: errorCompany } = useHookCompanyByCompany()

  // State untuk Foto Profil
  const [preview, setPreview] = useState(null);
  const [data, setData] = useState({
    name: "Andri Ardiansyah",
    email: "admin@danelanet.com",
    phone_number: "0812-3456-7890",
    price: "150000", // <-- TAMBAHKAN INI
  });

  // State untuk Perusahaan
  const [companyPreview, setCompanyPreview] = useState(null);
  const [companyData, setCompanyData] = useState({
    name: "PT. Danela Net Indonesia",
    short_name: "DANELA",
    address: "Jl. Raya Teknologi No. 123, Kecamatan Cyber, Kota Network, Provinsi Digital 12345",
  });



  // --- HANDLERS PROFIL ---
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (preview) URL.revokeObjectURL(preview);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    if (preview) URL.revokeObjectURL(preview);
    setPreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setData((prev) => ({ ...prev, [id]: value }));
  };



  // Style input yang seragam untuk Dark Theme
  const inputClass =
    "w-full px-4 py-3 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all";

  // Helper mendapat data paket yang aktif
  const currentPlan = subscriptionPackages.find((p) => p.id === activePackage);

  return (
    <>
      <Helmet>
        <title>Pengaturan - DANELA NET</title>
      </Helmet>

      <DashboardLayout showSidebar={openSidebar} setShowSidebar={setOpenSidebar}>
        {/* ===== Header ===== */}
        <Header toggleSidebar={() => setOpenSidebar(!openSidebar)}>
          <div className="flex flex-col">
            <h2 className="text-base md:text-xl font-display font-bold text-gray-100 tracking-tight">
              Pengaturan Akun
            </h2>
            <p className="text-xs text-slate-500 hidden md:block mt-0.5">
              Kelola informasi profil, sistem, dan keamanan akun Anda.
            </p>
          </div>
        </Header>

        {/* ===== Content ===== */}
        <main className="p-4 lg:p-6 max-w-6xl"> {/* Diperlebar sedikit untuk muat 3 kolom paket */}
          <div className="flex flex-col md:flex-row gap-6">
            {/* Sidebar Tabs */}
            <HeaderTabSetting activeTab={activeTab} setActiveTab={setActiveTab} />

            {/* Content Area */}
            <div className="flex-1">
              <article
                className="rounded-2xl overflow-hidden"
                style={{
                  background: "rgba(15, 23, 42, 0.5)",
                  border: "1px solid rgba(51, 65, 85, 0.3)",
                  backdropFilter: "blur(12px)",
                }}
              >
                <div className="p-6 space-y-6">

                  {/* ==================== TAB PROFIL ==================== */}
                  {activeTab === "profile" && (
                    <TabProfileSetting />
                  )}
                  
                  {/* ==================== TAB LANGGANAN (BARU) ==================== */}
                  {activeTab === "subscription" && (
                    <TabSubscriptionPlanSetting data={dataCompany} refreshData={refreshDataCompany} loading={loadingCompany} error={errorCompany} />
                  )}

                  {/* ==================== TAB PERUSAHAAN ==================== */}
                  {activeTab === "company" && (
                    <TabCompanySetting data={dataCompany} refreshData={refreshDataCompany} loading={loadingCompany} error={errorCompany} />
                  )}

                  {/* ==================== TAB SISTEM ==================== */}
                  {activeTab === "system" && (
                    <section className="space-y-6 animate-in fade-in duration-300">
                      <header>
                        <h3 className="text-lg font-bold text-gray-100">Konfigurasi Sistem</h3>
                        <p className="text-xs text-slate-500 mt-1">Pengaturan dasar aplikasi billing dan jaringan.</p>
                      </header>
                      <div className="space-y-4">
                        <div className="flex items-center justify-between p-4 rounded-xl" style={{ background: "rgba(15, 23, 42, 0.6)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
                          <div className="flex items-center gap-4">
                            <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-cyan-500/10 text-cyan-400 border border-cyan-500/20"><FaBell className="text-sm" /></div>
                            <div>
                              <p className="text-sm font-semibold text-gray-100">Notifikasi WhatsApp</p>
                              <p className="text-[11px] text-slate-500">Kirim tagihan otomatis via WA</p>
                            </div>
                          </div>
                          <ToggleSwitch defaultChecked={true} />
                        </div>
                        <div className="flex items-center justify-between p-4 rounded-xl" style={{ background: "rgba(15, 23, 42, 0.6)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
                          <div className="flex items-center gap-4">
                            <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-amber-500/10 text-amber-400 border border-amber-500/20"><FaGlobe className="text-sm" /></div>
                            <div>
                              <p className="text-sm font-semibold text-gray-100">Maintenance Mode</p>
                              <p className="text-[11px] text-slate-500">Nonaktifkan akses pelanggan sementara</p>
                            </div>
                          </div>
                          <ToggleSwitch defaultChecked={false} />
                        </div>
                      </div>
                    </section>
                  )}

                  {/* ==================== TAB KEAMANAN ==================== */}
                  {activeTab === "security" && (
                    <TabSecuritySetting />
                  )}
                </div>
              </article>
            </div>
          </div>
        </main>
      </DashboardLayout>
    </>
  );
};